import * as actions from '../utils/Constants';
import { apiGet } from '../utils/Api';


export const getAvailableFacultyList = (trainingId) => ({
    type: actions.SEARCH_FACULTY,
    payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/facultySearch`)
});
